export const currencySettingsData = [
  {
    id: "7",
    name: "New Zealand Dollar",
    symbol: "NZ$",
    code: "NZD",
  },
  {
    id: "4",
    name: "Australian Dollar",
    symbol: "A$",
    code: "AUD",
  },
  {
    id: "6",
    name: "Canadian Dollar",
    symbol: "C$",
    code: "CAD",
  },
  {
    id: "3",
    name: "British Pound",
    symbol: "£",
    code: "GBP",
  },
  {
    id: "2",
    name: "Euro",
    symbol: "€",
    code: "EUR",
  },
  {
    id: "5",
    name: "Sri Lankan Rupee",
    symbol: "Rs. ",
    code: "LKR",
  },
  {
    id: "1",
    name: "US Dollar",
    symbol: "$",
    code: "USD",
  },
];
